import type * as THREE from "three/webgpu";

export function orientBillboardToCamera(
  object: THREE.Object3D,
  camera: THREE.Camera,
  outQuat: THREE.Quaternion,
): void {
  camera.getWorldQuaternion(outQuat);
  object.quaternion.copy(outQuat);
}
